/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HorseUserRoleEnum } from '../models/HorseUserRoleEnum';
import { HttpFile } from '../http/http';

export class CreateHorseAccessInviteRequest {
    'user': number;
    'horse': string;
    'message'?: string;
    'role'?: HorseUserRoleEnum;
    'isTrainer'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "user",
            "baseName": "user",
            "type": "number",
            "format": ""
        },
        {
            "name": "horse",
            "baseName": "horse",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "HorseUserRoleEnum",
            "format": ""
        },
        {
            "name": "isTrainer",
            "baseName": "isTrainer",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return CreateHorseAccessInviteRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

